import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
};
export function SectionLabel({
  children,
  tone = 'dark'
}: SectionLabelProps) {
  const color = tone === 'dark' ? 'text-clay' : 'text-oat/80';
  const line = tone === 'dark' ? 'bg-clay/40' : 'bg-oat/30';
  return <p className={`mb-5 flex items-center gap-3 font-sans text-[11px] font-medium uppercase tracking-[0.28em] ${color}`} data-id="element-128" data-mp="33ddyqsprp455">
      <span className={`h-px w-8 ${line}`} aria-hidden="true" data-id="element-129" data-mp="3r3zyzxtj5k4l" />
      {children}
    </p>;
}